module.exports = __webpack_public_path__ + "assets/img/image-56-1280.52f4eb0b.webp";